var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlooklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.117,
    height: 21.673,
    viewBox: "0 0 23.117 21.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outlook_732223",
    transform: "translate(0 -15.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374939",
    "data-name": "Path 374939",
    d: "M266.836,112.011H256.722a.722.722,0,0,0,0,1.445h8.009l-4.439,3.452-3.183-2.024-.774,1.219,3.612,2.3a.723.723,0,0,0,.831-.039l5.336-4.151v9.36h-9.391a.722.722,0,0,0,0,1.445h10.114a.723.723,0,0,0,.722-.722V112.733A.723.723,0,0,0,266.836,112.011Z",
    transform: "translate(-244.441 -91.686)",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374940",
    "data-name": "Path 374940",
    d: "M12.742,16.157A.71.71,0,0,0,12.148,16L.589,18.171A.72.72,0,0,0,0,18.88V34.773a.722.722,0,0,0,.589.709L12.148,37.65a.68.68,0,0,0,.133.013A.722.722,0,0,0,13,36.94V16.713A.72.72,0,0,0,12.742,16.157Z",
    transform: "translate(0 0)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374941",
    "data-name": "Path 374941",
    d: "M67.612,184.68c-1.991,0-3.612-1.945-3.612-4.334s1.621-4.334,3.612-4.334,3.612,1.945,3.612,4.334S69.6,184.68,67.612,184.68Zm0-7.224c-1.195,0-2.167,1.3-2.167,2.89s.972,2.89,2.167,2.89,2.167-1.3,2.167-2.89S68.807,177.456,67.612,177.456Z",
    transform: "translate(-61.11 -152.796)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlooklogo);
export default __webpack_public_path__ + "static/media/outlooklogo.eaacc9e5db079b83c8a757ec60f4d5dc.svg";
export { ForwardRef as ReactComponent };